import { Injectable } from '@angular/core';
import { HttpService } from '@app/core/http/http.service';

import { Observable } from 'rxjs';
import { FileDownloadedEntry } from '@app/shared/models/FileDownloadedEntry';

@Injectable()
export class ContractReportService {

  private sApiContractReports = '/api/contractAccount/';

  constructor(private httpService: HttpService) { }

  public downloadContractReport(MaestronetLoginId: number): Observable<any> {
    // Por ahora, es el único valor válido
    const reportType = "contracts";
    return this.httpService.get<FileDownloadedEntry>(this.sApiContractReports + MaestronetLoginId + '/reports/' + reportType);
  }
}
